module.exports = __webpack_public_path__ + "img/15.e4502bf9.png";